import { THTooltip } from '@repo/ui';
import { ComponentProps, PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import styles from './KitVersionUpdateTooltip.module.css';

type Props = {
  kitId?: string;
  position?: ComponentProps<typeof THTooltip>['position'];
};

export default function KitVersionUpdateTooltip({
  kitId,
  children,
  position,
}: PropsWithChildren<Props>) {
  const { hasOutdatedKitVersion } = useKitSystemInfo(kitId);

  const navigate = useNavigate();

  function handleUpdate() {
    navigate('/results/update');
  }

  return (
    <THTooltip
      title='Version update available'
      description='Update to the latest version to ensure past results reflect the latest science.'
      actions={[{ label: 'Update old reports', onClick: handleUpdate }]}
      hidden={!hasOutdatedKitVersion}
      wrapperClassName={styles.wrapper}
      position={position}
    >
      {children}
    </THTooltip>
  );
}
